/**
 * Returns the url only when it is a safe navigation / iframe target, otherwise null.
 *
 * Accepts an app-relative path (`/...`) or an absolute `http(s)://` URL (SSO logout can
 * legitimately redirect to an external identity provider, so cross-origin https is allowed).
 * Rejects `javascript:`, `data:`, `vbscript:` and other script-bearing schemes, and
 * protocol-relative targets in any slash/backslash form that could be used for an open redirect.
 */
export function safeHttpUrl(url: string | null | undefined): string | null {
  if (!url || typeof url !== 'string') {
    return null
  }
  const trimmed = url.trim()
  // Protocol-relative targets in any form ( //host  /\host  \/host  \\host ): browsers normalise
  // `\` to `/` for http(s), so e.g. `/\evil.com` resolves to `//evil.com` -> an open redirect.
  if (/^[/\\]{2}/.test(trimmed)) {
    return null
  }
  if (trimmed.startsWith('/')) {
    return trimmed
  }
  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed
  }
  return null
}
